// extracted by mini-css-extract-plugin
export default {"facebook-share-link":"facebook-share-link--mp-T7paM","facebookShareLink":"facebook-share-link--mp-T7paM"};